module.exports = __webpack_public_path__ + "static/media/generic_lead.7086bb88.jpg";